import React from 'react';
import Icon from '../../../components/AppIcon';

const CompanySizeSelector = ({ sizes, selectedSize, onSelect }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {sizes?.map((size) => (
        <button
          key={size?.value}
          onClick={() => onSelect(size?.value)}
          className={`p-4 rounded-lg border-2 transition-all ${
            selectedSize === size?.value
              ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50 bg-card'
          }`}
        >
          <div className="flex flex-col items-center text-center gap-2">
            <div
              className={`p-3 rounded-full ${
                selectedSize === size?.value
                  ? 'bg-primary text-white' :'bg-muted text-foreground'
              }`}
            >
              <Icon name={size?.icon} size={20} />
            </div>
            <div>
              <div className="font-semibold text-foreground text-sm mb-1">
                {size?.label}
              </div>
              <div className="text-xs text-muted-foreground">{size?.range}</div>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default CompanySizeSelector;